import React from 'react';
import './BatteryTotalsCards.scss';

const BatteryTotalsCards = ({ item }) => {
  return (
    <div className="battery-totals-cards">
      <p className="subhead battery-totals-cards-heading">Battery Totals</p>

      <div className="totals-cards-grid">
        <div className="totals-card soc">
          <img
            className="icon"
            src={require(`../../assets/kiosk/battery${item.batteryDisplaySoc}.svg`)}
            alt="Current Battery SOC % graphic"
            width="42"
            height="42"
          />
          <div className="totals-card-text">
            <p className="label">Battery SOC</p>
            <p className="value">{`${item.socPercent}% / ${item.sockWh} kWh`}</p>
          </div>
        </div>

        <div className="totals-card">
          <div className="totals-card-text">
            <p className="label">Current Power</p>
            <p className="value">{`${item.realPowerkW} kW`}</p>
          </div>
        </div>

        <div className="totals-card">
          <div className="totals-card-text">
            <p className="label">Capacity</p>
            <p className="value">{`${item.capacitykWh} kWh`}</p>
          </div>
        </div>

        <div className="totals-card">
          <div className="totals-card-text">
            <p className="label">Max Charge</p>
            <p className="value">{`${item.chargeCapacitykW} kW`}</p>
          </div>
        </div>

        <div className="totals-card">
          <div className="totals-card-text">
            <p className="label">Max Discharge</p>
            <p className="value">{`${item.dischargeCapacitykW} kW`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatteryTotalsCards;
